export const seoFragment =
  `meta: _seoMetaTags {
    attributes
    content
    tag
  }`

export const ctaFragment = `
  ctaLink
  ctaCopy
  showCta
`

export const mediaFragment = (mediaType = 'image') =>
  `${mediaType} {
    alt
    height
    width
    title
    src: url
    focalPoint {
      x
      y
    }
  }`

export const typeFragment = 'type: _modelApiKey'
export const displayFragment = `
  visibility
  skuPattern
  disableBottomMargin
`

export const headingRecord = `
  ... on HeadingRecord {
    ${typeFragment}
    ${displayFragment}
    title
    titleGradient
    titleSize
    subtitle
    subtitleGradient
    copy
    copySize
    showCta
    ctaCopy
    ctaLink
  }`

export const standfirstRecord = `
  ... on StandfirstRecord {
    ${typeFragment}
    ${displayFragment}
    title
    largeTitle
    subtitle
    fullWidth
  }`

export const dividerRecord = `
  ... on DividerRecord {
    ${typeFragment}
    ${displayFragment}
  }`

export const bannerFragment = `
  ${typeFragment}
  ${displayFragment}
  ${mediaFragment()}
  ${ctaFragment}
  displayTitle
  titleSize
  copy
  primaryColour
  fullWidth
  ctaGradient
  matchHeightToContent
  minHeight
  disableParallax
`

export const bannerRecord = `
  ... on BannerRecord {
    ${bannerFragment}
  }`

export const multiColumnRecord = `
  ... on MultiColumnRecord {
    id
    ${typeFragment}
    ${displayFragment}
    carouselOnMobile
    columns {
      ... on BlankRecord {
        id
        ${typeFragment}
      }
      ... on ProductCardRecord {
        ${typeFragment}
        showTag
        tagCopy
        imageNumber
        products {
          sku
          title
          subTitle
          frameSwatchOverride
          lensSwatchOverride
          swatchIconOverride {
            url(imgixParams: {w: "50", h: "50"})
          }
          lensPart
          limitedEdition
          stockManagedPart
        }
      }
      ... on StackRecord {
        ${typeFragment}
        ${mediaFragment()}
        ${ctaFragment}
        link
        title
        titleSize
        subtitle
        copy
        copySize
        ctaType
        aspectRatio
      }
      ... on BannerCardRecord {
        ${typeFragment}
        ${mediaFragment()}
        displayTitle
        titleSize
        primaryColour
        copy
      }
    }
  }`

export const videoRecord = `
  ... on VideoRecord {
    ${typeFragment}
    ${displayFragment}
    id
    loop
    muted
    autoPlay
    previewStartTime
    previewDuration
    fullWidth
    transform
    transformSizing
    ${mediaFragment('video')}
  }`

export const richTextRecord = `
  ... on RichTextRecord {
    ${typeFragment}
    id
    content
    ${displayFragment}
  }`

export const rowsFragment = `{
    ${headingRecord}
    ${dividerRecord}
    ${bannerRecord}
    ${videoRecord}
    ${standfirstRecord}
    ${multiColumnRecord}
    ${richTextRecord}
  }
`

export const builderFragment = `
  pageTheme
  rows ${rowsFragment}
  title
  ${seoFragment}
`